import { createApi } from '@redux/createApi';

const tags = {
  getFiatAssets: 'getFiatAssets',
  getFiatAssetActivity: 'getFiatAssetActivity',
  setFiatAssetActivity: 'setFiatAssetActivity',
  getSystemBlock: 'getSystemBlock',
  setSystemBlock: 'setSystemBlock',
};

export const fiatAssetsApi = createApi({
  reducerPath: 'fiatAssetsApi',
  tagTypes: [tags.getFiatAssets, tags.getFiatAssetActivity, tags.getSystemBlock],
  endpoints: (builder) => ({
    getFiatAssets: builder.query({
      query: () => {
        return ({
          method: 'get',
          url: `/admin/fiat-assets`,
        });
      },
      providesTags: [tags.getFiatAssets],
      serializeQueryArgs: ({ queryArgs }) => {
        return { ...queryArgs };
      },
    }),
    getFiatAssetActivity: builder.query({
      query: () => {
        return ({
          method: 'get',
          url: `/admin/fiat-asset/activity`,
        });
      },
      providesTags: [tags.getFiatAssetActivity],
      serializeQueryArgs: ({ queryArgs }) => {
        return { ...queryArgs };
      },
    }),
    setFiatAssetActivity: builder.mutation({
      query: ({ asset, active }) => {
        return ({
          method: 'post',
          url: `/admin/fiat-asset/activity`,
          body: {
            asset,
            active,
          },
        });
      },
      providesTags: [tags.setFiatAssetActivity],
      invalidatesTags: [tags.getFiatAssetActivity],
    }),
    getSystemBlock: builder.query({
      query: () => {
        return ({
          method: 'get',
          url: `/admin/system/block`,
        });
      },
      providesTags: [tags.getSystemBlock],
      serializeQueryArgs: ({ queryArgs }) => {
        return { ...queryArgs };
      },
    }),
    setSystemBlock: builder.mutation({
      query: ({ active, minutes }) => {
        return ({
          method: 'post',
          url: `/admin/system/block`,
          body: {
            active,
            minutes,
          },
        });
      },
      providesTags: [tags.setSystemBlock],
      invalidatesTags: [tags.getSystemBlock],
    }),
  }),
});

export const {
  useGetFiatAssetsQuery,
  useGetFiatAssetActivityQuery,
  useSetFiatAssetActivityMutation,
  useGetSystemBlockQuery,
  useSetSystemBlockMutation,
} = fiatAssetsApi;
